export default function PandemicPlanController(
  $scope,
  alerts,
  bcpDataService,
  loaderService,
  ssDialogService,
  userService,
  editPandemicPlanProcedureDialog
) {
  const vm = this;

  vm.canExpand = !!vm.procedure && !!vm.procedure.pandemicInformation;
  vm.isExpanded = false;
  vm.hasData = false;

  vm.handleExpand = _handleExpand;
  vm.handleEditPandemicPlanProcedures = _handleEditPandemicPlanProcedures;
  vm.statusComplete = _statusComplete;

  _activate();

  // //////// METHODS //////////

  function _handleExpand() {
    if (!vm.hasData) {
      return _loadProcesses();
    }
    return Promise.resolve();
  }

  function _activate() {
    _initPermissions();
    _loadProcesses();
  }

  function _initPermissions() {
    return userService.getUserPermissionSet('bcp').then((permissions) => {
      vm.permissions = permissions;
    });
  }

  function _statusComplete() {
    return vm.procedure && vm.procedure.pandemicInformation;
  }

  function _handleEditPandemicPlanProcedures($event) {
    _loadProcesses().then(() => _openEditPandemicPlanProceduresDialog($event, {
      assessmentId: vm.assessmentId,
      procedure: vm.procedure,
    }));
  }

  /** *********************************************
   * Private Functions
   */

  function _openEditPandemicPlanProceduresDialog($event, locals) {
    ssDialogService.dialogs.bcp.editPandemicPlanProcedureDialog = ssDialogService.alert(
      editPandemicPlanProcedureDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.bcp.editPandemicPlanProcedureDialog);
  }

  function _loadProcesses() {
    loaderService.showViewLoader = true;
    return bcpDataService.getPandemicPlanProcedures(vm.assessmentId)
      .then((procedures) => {
        loaderService.showViewLoader = false;
        vm.procedure = procedures.data || {};
        vm.hasData = true;
        vm.canExpand = !!vm.procedure && !!vm.procedure.pandemicInformation;
      })
      .catch(() => {
        loaderService.showViewLoader = false;
        alerts.error('An error occurred while fetching the Pandemic Plan Procedure.');
      });
  }
}

PandemicPlanController.$inject = [
  '$scope',
  'alerts',
  'bcpDataService',
  'loaderService',
  'ssDialogService',
  'userService',
  'editPandemicPlanProcedureDialog'
];
